import { FadeLoader } from 'react-spinners';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container, Stack, Typography } from '@mui/material';
import Page from '../../components/Page';
import tracker from '../../api/tracker';
import AttendanceForm from '../../sections/@dashboard/attendances/AttendanceForm';
import PrintButton from '../../components/print/PrintButton';
import AttendancePrintTemplate from '../../sections/@dashboard/attendances/AttendancePrintTemplate';

// ---------------------------------------------------------------------

export default function EditAttendance() {
  const [loading, setLoading] = useState(true);
  const { hashid } = useParams();
  const [attendance, setAttendance] = useState();
  const { t } = useTranslation();

  const fetchAttendanceData = async () => {
    const response = await tracker.get(`attendance/${hashid}`);
    setAttendance(response.data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchAttendanceData();
  }, [hashid]);

  return (
    <>
      <AttendancePrintTemplate attendance={attendance} />
      <Page title={t('attendance_form')}>
        <Container maxWidth="xl">
          <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1} sx={{ mb: 4 }}>
            <Typography variant="h4" fontWeight={800} sx={{ color: '#032C65' }}>
              {t('edit_attendance') || 'Editar Asistencia'}
            </Typography>
            {!loading && attendance && <PrintButton />}
          </Stack>
          <Box sx={{ background: '#fff', borderRadius: 3, p: { xs: 2, md: 4 }, boxShadow: '0 1px 8px 0 rgba(3,44,101,0.07)' }}>
            {loading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
                <FadeLoader color="#032C65" cssOverride={{ margin: '0 auto' }} loading={loading} />
              </Box>
            ) : (
              <AttendanceForm attendance={attendance} />
            )}
          </Box>
        </Container>
      </Page>
    </>
  );
}